import { AfterViewInit, ChangeDetectionStrategy, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { OperatorNote, OperatorNoteReason } from 'src/models/task-event';

type DialogMode = 'edit' | 'remove';

export interface OperatorNoteDialogInput {
  taskName: string;
  operatorNote: OperatorNote;
  mode: DialogMode;
}

@Component({
  selector: 'app-comment-dialog',
  templateUrl: './operator-note-dialog.component.html',
  styleUrls: ['./operator-note-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OperatorNoteDialogComponent implements OnInit, AfterViewInit {

  @ViewChild('operatorNote')
  operatorNote!: ElementRef<HTMLTextAreaElement>;

  reasonOptions: { key: string; value: OperatorNoteReason; }[];
  _selectedReason!: OperatorNoteReason | null;
  get selectedReason(): string {
    return this._selectedReason?.toString() || '';
  }
  set selectedReason(value: string) {
    this._selectedReason = parseInt(value) as OperatorNoteReason;
  }

  private mode: DialogMode;
  get isRemoveMode(): boolean { return this.mode === 'remove'; }

  constructor(
    public dialogRef: MatDialogRef<OperatorNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public input: OperatorNoteDialogInput
  ) {
    this.reasonOptions =
      Object.keys(OperatorNoteReason)
        .filter(value => !isNaN(Number(value)))
        .map((value: any) => ({ key: OperatorNoteReason[value], value }));
    this._selectedReason = this.input.operatorNote.operatorNoteReason;
    this.mode = input.mode;
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.operatorNote.nativeElement.value = this.input.operatorNote.operatorNote || '';
  }

  get isOperatorNoteRequired(): boolean {
    return this._selectedReason === OperatorNoteReason.Other;
  }

  private get isOperatorNoteValid(): boolean {
    return !this.isOperatorNoteRequired || this.operatorNote?.nativeElement?.value.trim().length !== 0 || false;
  }

  get canSubmit(): boolean {
    return !!this.selectedReason && this.isOperatorNoteValid;
  }

  getResult = (): OperatorNote => {
    return {
      operatorNoteReason: this._selectedReason!,
      operatorNote: this.operatorNote?.nativeElement?.value
    }
  }
}
